import { cymbioColors } from '../../utils/colors';
import { SquareWithRoundBordersShape } from './SquareWithRoundBordersShape';

export const GRAPH_CURRENCY_FORMAT = ' >-$0,.2f';
export const GRAPH_REGULAR_FORMAT = ' >-,.0f';

export const MAX_DISPLAYED_RETAILERS = 10;

export const IncludeOnlyType = {
  CANCELLED: 'cancelled',
  RETURNED: 'returned',
  HAS_RLRS: 'has_rlrs',
};

export const baseLegend = {
  anchor: 'right',
  direction: 'column',
  justify: false,
  translateX: 100,
  translateY: 0,
  itemsSpacing: 4,
  itemWidth: 120,
  itemHeight: 14,
  itemTextColor: cymbioColors.analytics.textSecondary,
  itemOpacity: 1,
  symbolShape: SquareWithRoundBordersShape,
  effects: [
    {
      on: 'hover',
      style: {
        itemTextColor: cymbioColors.black,
      },
    },
  ],
};

export const graphColors = [
  '#9AADEF',
  '#36DFCD',
  '#B690FF',
  '#FF8B86',
  '#FCE285',
  '#45CDFF',
  '#F69BF5',
  '#7BF7FF',
  '#9DF2AA',
  '#FCBF85',
  '#CFCFCF',
];

export const graphTheme = {
  fontFamily: '"Nunito", sans-serif',
  legends: {
    text: {
      fontWeight: 300,
      fontSize: 12,
    },
  },
  labels: {
    text: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: 10,
      fontWeight: 700,
      opacity: 0.5,
      color: 'black',
    },
  },
  axis: {
    ticks: {
      text: {
        fontFamily: '"Rubik", sans-serif',
        fontWeight: 300,
        fontSize: 10,
        color: cymbioColors.analytics.textSecondary,
      },
    },
  },
};
